import { render, staticRenderFns } from "./ApplicationDetailView.vue?vue&type=template&id=22b08acc&scoped=true"
import script from "./ApplicationDetailView.vue?vue&type=script&lang=js"
export * from "./ApplicationDetailView.vue?vue&type=script&lang=js"
import style0 from "./ApplicationDetailView.vue?vue&type=style&index=0&id=22b08acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b08acc",
  null
  
)

export default component.exports